import { environment } from '~env/environment';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { CountryCode } from './country-code.enum';
import {
  APP_ADDRESSES_ROUTE,
  APP_AUTH_ROUTE,
  APP_BILLING_ROUTE,
  APP_CART_ROUTE,
  APP_CATEGORY_ROUTE,
  APP_CHECKOUT_ROUTE,
  APP_ENTREPRENEUR_ACCOUNT_ROUTE,
  APP_LEGAL_PAGE_ABOUT,
  APP_LEGAL_PAGE_CANCELLATION_POLICY,
  APP_LEGAL_PAGE_DISPOSAL_AND_ENV,
  APP_LEGAL_PAGE_IMPRINT,
  APP_LEGAL_PAGE_PRIVACY_POLICY,
  APP_LEGAL_PAGES_ROUTE,
  APP_PRODUCT_ROUTE,
  APP_SHIPPING_ROUTE,
  APP_SUPPORT_ROUTE,
  CHECKOUT_ROUTE,
  LOGIN_ROUTE,
  ORDER_ROUTE,
  ORDER_STEP_ADDRESS,
  ORDER_STEP_PAYMENT,
  ORDER_STEP_REVIEW,
  REGISTRATION_ROUTE,
  USER_ADD_BUSINESS_ROUTE,
} from './routes.constants';

// local constants to fix sonar reporting
const TERMS_AND_CONDITIONS_LINK_IT = 'https://www.metro.it/termini-e-condizioni';

export const CART_LINK = `/${APP_CHECKOUT_ROUTE}/${APP_CART_ROUTE}`;
export const CHECKOUT_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}`;
export const ORDER_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}`;
export const ORDER_STEP_ADDRESS_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}/${ORDER_STEP_ADDRESS}`;
export const ORDER_STEP_PAYMENT_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}/${ORDER_STEP_PAYMENT}`;
export const ORDER_STEP_REVIEW_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}/${ORDER_STEP_REVIEW}`;

export const BILLING_ADDRESS_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}/${APP_ADDRESSES_ROUTE}/${APP_BILLING_ROUTE}`;
export const SHIPPING_ADDRESS_LINK = `/${APP_CHECKOUT_ROUTE}/${CHECKOUT_ROUTE}/${ORDER_ROUTE}/${APP_ADDRESSES_ROUTE}/${APP_SHIPPING_ROUTE}`;

export const AUTH_LOGIN_LINK = `/${APP_AUTH_ROUTE}/${LOGIN_ROUTE}`;
export const AUTH_REGISTER_LINK = `/${APP_AUTH_ROUTE}/${REGISTRATION_ROUTE}`;
export const AUTH_PASSWORDLESS_SIGNUP_LINK = `/${APP_AUTH_ROUTE}/passwordless-signup`;
export const AUTH_PASSWORD_RESTORATION_LINK = `/${APP_AUTH_ROUTE}/password-restoration`;
export const AUTH_AFTER_PASSWORD_RESTORATION_LINK = `/${APP_AUTH_ROUTE}/after-password-restoration`;
export const AUTH_EMAIL_VALIDATION_LINK = `/${APP_AUTH_ROUTE}/email-validation`;
export const AUTH_VALIDATE_EMAIL_LINK = `/${APP_AUTH_ROUTE}/validate-email`;
export const AUTH_AFTER_EMAIL_VALIDATION_LINK = `/${APP_AUTH_ROUTE}/after-email-validation`;
export const ACCOUNT_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}`;
export const AUTH_PASSWORDLESS_ADD_BUSINESS_DETAILS_LINK = `/${APP_AUTH_ROUTE}/${REGISTRATION_ROUTE}/passwordless-business-details`;
// todo: DMO_change
export const ACCOUNT_INFORMATION_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/info`;
export const ACCOUNT_AFTER_CHANGE_EMAIL_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/after-change-email`;
export const ACCOUNT_CHANGE_EMAIL_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/info/change-email`;
export const ACCOUNT_EDIT_BUSINESS_INFORMATION_LINK = `${ACCOUNT_INFORMATION_LINK}/edit-business-info`;
export const ACCOUNT_ADD_BUSINESS_INFORMATION_LINK = `${ACCOUNT_INFORMATION_LINK}/add-business-info`;
export const ACCOUNT_ADD_BUSINESS_DETAILS_LINK = `${AUTH_REGISTER_LINK}/add-business-details`;
export const ACCOUNT_VAT_NUMBER_CHECK_LINK = `${AUTH_REGISTER_LINK}/check-vat`;
export const ACCOUNT_TAX_ID_CHECK_LINK = `${AUTH_REGISTER_LINK}/check-tax-id`;
export const ACCOUNT_BRANCH_SELECTION_CHECK_LINK = `${AUTH_REGISTER_LINK}/branch-selection`;
export const ACCOUNT_ADD_BUSINESS_LINK = `${AUTH_REGISTER_LINK}/${USER_ADD_BUSINESS_ROUTE}`;
export const ACCOUNT_ADDRESS_BOOK_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/address-book`;
export const ACCOUNT_ADD_CARD_URL = () => `${environment.myMetroBaseUrl()}/register/add-card/card`;
export const ADD_METRO_CARD_URL = 'register/add-card/card';
export const PASSWORDLESS_INTERMEDIATE_URL = `${APP_AUTH_ROUTE}/passwordless-intermediate`;

export const ORDER_HISTORY_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/orders-history`;
export const ORDER_HISTORY_LINK_PERSONAL = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/orders-history?context=personal`;
export const ORDER_HISTORY_LINK_EXTERNAL = () =>
  `${environment.appBaseUrl()}/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/orders-history`;
export const ORDER_HISTORY_LINK_PERSONAL_EXTERNAL = () =>
  `${environment.appBaseUrl()}/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/orders-history?context=personal`;
export const STORED_PAYMENT_METHOD_LINK = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/stored-payment-methods`;

export const BUY_AGAIN = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/buy-again`;
export const YOUR_ASSORTMENT = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/your-assortment`;
export const YOUR_ASSORTMENT_EXTERNAL = () =>
  `${environment.appBaseUrl()}/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/your-assortment`;
export const BUY_AGAIN_EXTERNAL = () =>
  `${environment.appBaseUrl()}/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/buy-again`;
export const SHOPPING_LIST_V2 = `/shopping-list`;
export const MULTIPLE_SHOPPING_LIST = `/shopping-lists`;
export const APPROVAL_DASHBOARD = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/approve-orders`;
export const ACCESS_DENIED_PAGE = `/${APP_ENTREPRENEUR_ACCOUNT_ROUTE}/access-denied`;
export const LEGAL_MY_METRO_AGB_DE = 'https://www.metro.de/unternehmen/agb_account';
export const LEGAL_COMPANION_APP_AGB_DE = 'https://www.metro.de/unternehmen/agb_companionapp';
export const LEGAL_METRO_MARKETS_AGB_DE = 'https://www.metro.de/unternehmen/agb_marktplatz';
export const LEGAL_CANCELLATION_POLICY_DE = 'https://www.metro.de/unternehmen/widerrufsbedingungen_account';
export const LEGAL_DATA_PROTECTION_DE = 'https://www.metro.de/unternehmen/datenschutzallgemein';
export const LEGAL_DATA_PROTECTION_NL = 'https://www.makro.nl/privacyverklaring-webshop';

export const METRO_CUSTOMER_SUPPORT_DE = 'https://metro-markets.freshdesk.com/de/support/tickets/new';
export const MAKRO_CUSTOMER_SUPPORT_ES = 'https://metro-markets.freshdesk.com/es/support/tickets/new';
export const SUBSIDIARY_SUPPORT_EMAIL = 'mailto:de_vip_support@metro-marketplace.eu';
export const SUBSIDIARY_SUPPORT_EMAIL_NL = 'mailto:nl_vip_support@metro-marketplace.eu';

export const LEGAL_TERMS_AND_CONDITIONS_LINK_DE = 'https://www.metro.de/unternehmen/agb_allgemein';
export const LEGAL_TERMS_AND_CONDITIONS_LINK_ES =
  'https://www.makro.es/terminos-y-condiciones/condiciones-cuenta-digital';
export const LEGAL_TERMS_AND_CONDITIONS_LINK_IT = TERMS_AND_CONDITIONS_LINK_IT;
export const LEGAL_TERMS_AND_CONDITIONS_LINK_PT = `https://www.makro.pt/cgv`;
export const METRO_LEGAL_TERMS_AND_CONDITIONS_LINK_FR = 'https://www.metro.fr/cgv_marketplace';
export const LEGAL_TERMS_AND_CONDITIONS_LINK_FR = 'https://www.metro.fr/cgv_compte';
export const LEGAL_PRIVACY_POLICY_LINK = `/${APP_LEGAL_PAGES_ROUTE}/${APP_LEGAL_PAGE_PRIVACY_POLICY}`;

export const LEGAL_PRIVACY_POLICY_LINK_ES = `https://www.makro.es/politica-privacidad`;
export const LEGAL_PRIVACY_POLICY_LINK_IT = 'https://metro.it/privacy-mercato-online';
export const LEGAL_PRIVACY_POLICY_LINK_PT = 'https://www.makro.pt/politica-privacidade';
export const LEGAL_PRIVACY_POLICY_LINK_NL = 'https://www.makro.nl/juridisch/privacy-statement';
export const LEGAL_PRIVACY_POLICY_LINK_FR = 'https://www.metro.fr/traitement-donnees-personnelles';
export const LEGAL_PRIVACY_POLICY_LINK_TEXT_IT = 'Informativa sul trattamento dei dati personali';
export const LEGAL_PRIVACY_POLICY_LINK_TEXT_PT = 'Políticas de Privacidade';
export const LEGAL_PRIVACY_COOKIES_LINK_IT = `https://www.metro.it/cookie`;
export const LEGAL_PRIVACY_COOKIES_LINK_TEXT_IT = 'Informazioni sui cookie';
export const LEGAL_PRIVACY_COOKIES_LINK_TEXT_PT = 'Informações sobre cookies';
export const LEGAL_PRIVACY_COOKIES_LINK_ES = 'https://www.makro.es/cookies';
export const LEGAL_PRIVACY_COOKIES_LINK_PT = 'https://www.makro.pt/cookie-settings';
export const LEGAL_PRIVACY_COOKIES_LINK_NL = 'https://www.makro.nl/cookies';
export const HOME_LINK_TEXT_1_ES = 'https://www.makro.es';
export const HOME_LINK_TEXT_FR = 'https://www.metro.fr';
export const LEGAL_ABOUT_LINK = `/${APP_LEGAL_PAGES_ROUTE}/${APP_LEGAL_PAGE_ABOUT}`;
export const LEGAL_IMPRINT_LINK = `/${APP_LEGAL_PAGES_ROUTE}/${APP_LEGAL_PAGE_IMPRINT}`;
export const LEGAL_CANCELLATION_POLICY_LINK = `/${APP_LEGAL_PAGES_ROUTE}/${APP_LEGAL_PAGE_CANCELLATION_POLICY}`;
export const LEGAL_DISPOSAL_AND_ENV_LINK = `/${APP_LEGAL_PAGES_ROUTE}/${APP_LEGAL_PAGE_DISPOSAL_AND_ENV}`;
export const APP_SELLER_LANDING_LINK = () => `${environment.appSellerUrl()}`;
export const APP_SELLER_LOGIN_LINK = () => `${environment.appSellerUrl()}/login`;
export const BUYER_SUPPORT_LINK = `/${APP_SUPPORT_ROUTE}`;
export const DE_BUYER_SUPPORT_EXTERNAL_LINK = 'https://metro-markets.freshdesk.com/support/home';
export const ES_BUYER_SUPPORT_EXTERNAL_LINK = 'https://support-es.metro-marketplace.eu/es/support/home';
export const IT_BUYER_SUPPORT_EXTERNAL_LINK = 'https://support-it.metro-marketplace.eu/it/support/home';
export const PT_BUYER_SUPPORT_EXTERNAL_LINK = 'https://support-pt.metro-marketplace.eu/pt-PT/support/home';
export const NL_BUYER_SUPPORT_EXTERNAL_LINK = 'https://support-nl.metro-marketplace.eu/en/support/home';
export const FR_BUYER_SUPPORT_EXTERNAL_LINK = 'https://support-fr.metro-marketplace.eu/fr/support/home';
export const BUYER_SUPPORT_TICKET_NEW_LINK = 'https://metro-markets.freshdesk.com/support/tickets/new';
export const ES_BUYER_SUPPORT_TICKET_NEW_LINK = 'https://support-es.metro-marketplace.eu/es/support/tickets/new';
export const IT_BUYER_SUPPORT_TICKET_NEW_LINK = 'https://support-it.metro-marketplace.eu/it/support/tickets/new';
export const PT_BUYER_SUPPORT_TICKET_NEW_LINK = 'https://support-pt.metro-marketplace.eu/pt-PT/support/tickets/new';
export const NL_BUYER_SUPPORT_TICKET_NEW_LINK = 'https://support-nl.metro-marketplace.eu/nl/support/tickets/new';
export const FR_BUYER_SUPPORT_TICKET_NEW_LINK = 'https://support-fr.metro-marketplace.eu/fr/support/tickets/new';
export const SELLER_SUPPORT_HOME_LINK = 'https://metromarketssellersupport.freshdesk.com/support/home';
export const ES_SELLER_SUPPORT_HOME_LINK = 'https://metromarketssellersupport.freshdesk.com/es/support/home';
export const IT_SELLER_SUPPORT_HOME_LINK = 'https://metromarketssellersupport.freshdesk.com/it/support/home';
export const PT_SELLER_SUPPORT_HOME_LINK = 'https://metromarketssellersupport.freshdesk.com/pt-PT/support/home';
export const PT_SELLER_SUPPORT_CONTACT_FORM_LINK = 'https://www.metro-selleroffice.com/pt/';
export const NL_SELLER_HELP_CENTER = 'https://metromarketssellersupport.freshdesk.com/nl/support/home';
export const FR_SELLER_HELP_CENTER = 'https://metromarketssellersupport.freshdesk.com/fr/support/home';
export const NL_SELLER_START_SELLING = 'https://www.metro-selleroffice.com/nl';
export const FR_SELLER_START_SELLING = 'https://www.metro-selleroffice.com/fr/';
export const BUYER_EXTERNAL_MARKET_LINK = 'https://www.metro.de/mein-markt';
export const BUYER_EXTERNAL_DELIVERY_LINK = 'https://www.metro.de/lieferservice';
export const BUYER_EXTERNAL_SERVICE_LINK = 'https://www.metro.de/information-services';
export const BUYER_EXTERNAL_MARKET_LINK_ES = 'https://www.makro.es/tu-tienda';
export const BUYER_EXTERNAL_DELIVERY_LINK_ES = 'https://www.makro.es/distribucion-hosteleria/';
export const BUYER_EXTERNAL_SERVICE_LINK_ES = 'https://www.makro.es/info-y-servicios/';
export const BUYER_EXTERNAL_MARKET_LINK_IT =
  'https://www.metro.it/punto-vendita/?itm_pm=it:nav_my-store-bucket:ctr:bhc:0:0';
export const BUYER_EXTERNAL_DELIVERY_LINK_IT =
  'https://www.metro.it/consegne-horeca/?itm_pm=it:nav_delivery-bucket:ctr:bhc:0:0';
export const BUYER_EXTERNAL_SERVICE_LINK_IT =
  'https://www.metro.it/servizi-info/?itm_pm=it:nav_infos-and-services-bucket:ctr:bhc:0';
export const BUYER_EXTERNAL_MARKET_LINK_PT =
  'https://www.makro.pt/produtos-promocoes?itm_pm=pt:nav_my-store-bucket:ctr:bhc:0';
export const BUYER_EXTERNAL_DELIVERY_LINK_PT =
  'https://www.makro.pt/servico-de-entregas/?itm_pm=PT:nav_delivery-bucket:ctr:bhc:0 ';
export const BUYER_EXTERNAL_SERVICE_LINK_PT =
  'https://www.makro.pt/info-servicos/?itm_pm=PT:nav_infos-and-services-bucket:ctr:bhc:0';
export const BUYER_EXTERNAL_MARKET_LINK_NL = 'https://www.makro.nl/assortiment-en-acties';
export const BUYER_EXTERNAL_DELIVERY_LINK_NL = 'https://www.makro.nl/horeca-bezorgservice';
export const BUYER_EXTERNAL_SERVICE_LINK_NL =
  'https://www.makro.nl/informatie-en-service?itm_pm=nl:nav_infos-and-services-bucket:ctr:bhc:0:0';
export const BUYER_EXTERNAL_MARKET_LINK_FR = 'https://www.metro.fr/dispo-retrait-halles';
export const BUYER_EXTERNAL_DELIVERY_LINK_FR = 'https://www.metro.fr/abonnes-livraison';
export const BUYER_EXTERNAL_SERVICE_LINK_FR = 'https://www.metro.fr/conseil-service';

export const NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_PT = 'https://www.makro.pt/politica-privacidade/marketplace';
export const NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_NL = 'https://www.makro.nl/privacyverklaring-webshop';
export const NEWSLETTER_LEGAL_PRIVACY_POLICY_LINK_FR =
  'https://www.metro.fr/traitement-donnees-personnelles/marketplace';
export const BUYER_FAQ_EXTERNAL_LINK = 'https://metro-markets.freshdesk.com/support/solutions';
export const ES_BUYER_FAQ_EXTERNAL_LINK = 'https://support-es.metro-marketplace.eu/es/support/solutions';
export const IT_BUYER_FAQ_EXTERNAL_LINK = 'https://support-it.metro-marketplace.eu/it/support/solutions';
export const PT_BUYER_FAQ_EXTERNAL_LINK = 'https://support-pt.metro-marketplace.eu/pt-PT/support/solutions';
export const NL_BUYER_FAQ_EXTERNAL_LINK = 'https://support-nl.metro-marketplace.eu/nl/support/solutions';
export const FR_BUYER_FAQ_EXTERNAL_LINK = 'https://support-fr.metro-marketplace.eu/fr/support/solutions';
export const MM_CAREERS_LINK = 'https://www.metro-markets.de/careers/';
export const SHIPPING_INFO_LINK = 'https://metro-markets.freshdesk.com/support/solutions/folders/75000006680';
export const ES_SHIPPING_INFO_LINK = 'https://support-es.metro-marketplace.eu/es/support/solutions/folders/75000011577';
export const IT_SHIPPING_INFO_LINK = 'https://support-it.metro-marketplace.eu/it/support/solutions/folders/75000013693';
export const PT_SHIPPING_INFO_LINK =
  'https://support-pt.metro-marketplace.eu/pt-PT/support/solutions/folders/75000014168';
export const NL_SHIPPING_INFO_LINK =
  'https://support-nl.metro-marketplace.eu/nl/support/solutions/folders/103000177490';
export const FR_SHIPPING_INFO_LINK =
  'https://support-fr.metro-marketplace.eu/fr/support/solutions/folders/103000240848';
export const ORDER_INFO_LINK = 'https://metro-markets.freshdesk.com/support/solutions/folders/75000006677';
export const ES_ORDER_INFO_LINK = 'https://support-es.metro-marketplace.eu/es/support/solutions/folders/75000011576';
export const IT_ORDER_INFO_LINK = 'https://support-it.metro-marketplace.eu/it/support/solutions/folders/75000013691';
export const PT_ORDER_INFO_LINK = 'https://support-pt.metro-marketplace.eu/pt-PT/support/solutions/folders/75000014167';
export const NL_ORDER_INFO_LINK = 'https://support-nl.metro-marketplace.eu/nl/support/solutions/folders/103000177489';
export const FR_ORDER_INFO_LINK = 'https://support-fr.metro-marketplace.eu/fr/support/solutions/folders/103000240817';
export const RETURN_INFO_LINK = 'https://metro-markets.freshdesk.com/support/solutions/folders/75000006678';
export const ES_RETURN_INFO_LINK = 'https://support-es.metro-marketplace.eu/es/support/solutions/folders/75000011578';
export const IT_RETURN_INFO_LINK = 'https://support-it.metro-marketplace.eu/it/support/solutions/folders/75000013694';
export const PT_RETURN_INFO_LINK =
  'https://support-pt.metro-marketplace.eu/pt-PT/support/solutions/folders/75000014169';
export const NL_RETURN_INFO_LINK = 'https://support-nl.metro-marketplace.eu/nl/support/solutions/folders/103000177496';
export const FR_RETURN_INFO_LINK = 'https://support-fr.metro-marketplace.eu/fr/support/solutions/folders/103000240854';
export const SELLER_OFFICE_EXTERNAL_LINK = 'https://www.metro-selleroffice.com/';

export const DE_DISCOUNT_CODE_EXTERNAL_LINK = 'https://www.metro.de/unternehmen/agb_marktplatz/discountcodes';
export const ES_DISCOUNT_CODE_EXTERNAL_LINK =
  'https://www.makro.es/terminos-y-condiciones/marketplace/codigos-descuento';
export const IT_DISCOUNT_CODE_EXTERNAL_LINK = 'https://www.metro.it/termini-e-condizioni-codici-sconto';
export const PT_DISCOUNT_CODE_EXTERNAL_LINK = 'https://www.makro.pt/termos-e-condicoes-marketplace/codigos-de-desconto';
export const NL_DISCOUNT_CODE_EXTERNAL_LINK = 'https://www.makro.nl/algemene-voorwaarden-kortingscode';
export const FR_DISCOUNT_CODE_EXTERNAL_LINK = 'https://www.metro.fr/cgv_marketplace/codespromo';

export const DISCOUNT_CODE_EXTERNAL_LINKS = {
  [CountryCode.Germany]: DE_DISCOUNT_CODE_EXTERNAL_LINK,
  [CountryCode.Spain]: ES_DISCOUNT_CODE_EXTERNAL_LINK,
  [CountryCode.Italy]: IT_DISCOUNT_CODE_EXTERNAL_LINK,
  [CountryCode.Portugal]: PT_DISCOUNT_CODE_EXTERNAL_LINK,
  [CountryCode.Netherlands]: NL_DISCOUNT_CODE_EXTERNAL_LINK,
  [CountryCode.France]: FR_DISCOUNT_CODE_EXTERNAL_LINK,
};

export const LEGAL_DATA_PROTECTION_EXTERNAL_LINK = 'https://www.metro.de/unternehmen/datenschutzhinweise';
export const LEGAL_COOKIES_EXTERNAL_LINK = 'https://www.metro.de/unternehmen/datenschutzhinweise/cookies';
export const LEGAL_IMPRINT_EXTERNAL_LINK = 'https://www.metro.de/unternehmen/impressum';
export const LEGAL_AGB_EXTERNAL_LINK = 'https://www.metro.de/unternehmen/nutzungs-und-verkaufsbedingungen';
export const LEGAL_DISPOSAL_AND_ENV_EXTERNAL_LINK =
  'https://www.metro.de/unternehmen/entsorgungs-und-umweltbestimmungen';
export const LEGAL_DATA_PROTECTION_EXTERNAL_LINK_ES = 'https://www.makro.es/politica-privacidad';
export const LEGAL_IMPRINT_EXTERNAL_LINK_ES = 'https://www.makro.es/aviso-legal';
export const TERMS_AND_CONDITIONS_EXTERNAL_LINK_ES = 'https://www.makro.es/terminos-y-condiciones';
export const LEGAL_ENVIRONMENTAL_PROVISION_EXTERNAL_LINK = 'https://www.makro.es/disposiciones-ambientales';
export const LEGAL_PRIVACY_EXTERNAL_LINK_IT = 'https://www.metro.it/privacy';
export const LEGAL_COOKIES_EXTERNAL_LINK_IT = 'https://www.metro.it/cookie';
export const TERMS_AND_CONDITIONS_EXTERNAL_LINK_IT = TERMS_AND_CONDITIONS_LINK_IT;

export const LEGAL_IMPRINT_EXTERNAL_LINK_PT = 'https://www.makro.pt/aviso-legal';
export const LEGAL_COS_EXTERNAL_LINK_PT = 'https://www.makro.pt/cgv';
export const LEGAL_REGISTRATION_PRIVACY_POLICY_LINK_PT = 'https://www.makro.pt/politica-privacidade-registo-clientes';

export const LEGAL_IMPRINT_EXTERNAL_LINK_NL = 'https://www.makro.nl/juridisch/disclaimer';

export const LEGAL_TERMS_CONDITIONS_LINK_NL = 'https://www.makro.nl/juridisch/algemene-voorwaarden';
export const LEGAL_JURIDISCH_LINK_NL = 'https://www.makro.nl/juridisch';

export const LEGAL_CGV_LINK_FR = 'https://www.metro.fr/cgv';
export const LEGAL_COOKIES_FR = 'https://www.metro.fr/cookies-traceurs';
export const LEGAL_DONNEES_PERSONNEL_FR = 'https://www.metro.fr/traitement-donnees-personnelles';
export const LEGAL_MENTIONS_FR = 'https://www.metro.fr/mentions-legales';
export const LEGAL_EPR_FAQ_FR = 'https://support-fr.metro-marketplace.eu/fr/support/solutions/folders/103000488548';

export const CONDITION_LINK_TEXT_ES = 'https://www.makro.es/terminos-y-condiciones/marketplace';
export const CONDITION_LINK_TEXT_IT = 'Termini e condizioni';
export const CONDITION_LINK_TEXT_PT = 'Termos e Condições';
export const CONDITION_LINK_TEXT_FR = 'https://www.metro.fr/cgv';
export const DE_BUYER_OFFERS_EXTERNAL_LINK = 'https://www.metro.de/angebote';
export const PT_BUYER_COMPLAINT_BOOK_EXTERNAL_LINK = 'https://www.livroreclamacoes.pt/Inicio/';

export const OFFER_STORE_EXTERNAL_LINK_DE = 'https://produkte.metro.de/shop';
export const OFFER_STORE_EXTERNAL_LINK_ES = 'https://tienda.makro.es/shop';
export const OFFER_STORE_EXTERNAL_LINK_IT = 'https://prodotti.metro.it/shop';
export const OFFER_STORE_EXTERNAL_LINK_PT = 'https://produtos.makro.pt/shop';
export const OFFER_STORE_EXTERNAL_LINK_NL = 'https://producten.makro.nl/shop';
export const OFFER_STORE_EXTERNAL_LINK_FR = 'http://shop.metro.fr/shop';

export const OFFER_STORE_EXTERNAL_LINK = {
  [CountryCode.Germany]: OFFER_STORE_EXTERNAL_LINK_DE,
  [CountryCode.Spain]: OFFER_STORE_EXTERNAL_LINK_ES,
  [CountryCode.Italy]: OFFER_STORE_EXTERNAL_LINK_IT,
  [CountryCode.Portugal]: OFFER_STORE_EXTERNAL_LINK_PT,
  [CountryCode.Netherlands]: OFFER_STORE_EXTERNAL_LINK_NL,
  [CountryCode.France]: OFFER_STORE_EXTERNAL_LINK_FR,
};

export const FRESHDESK_INSTANCE_LINK = {
  [CountryCode.Germany]: 'https://metromarketsgmbh-help.freshdesk.com/de/support/tickets/new',
  [CountryCode.Spain]: 'https://metromarketsgmbh-help.freshdesk.com/es/support/tickets/new',
  [CountryCode.Italy]: 'https://metromarketsgmbh-help.freshdesk.com/it/support/tickets/new',
  [CountryCode.Portugal]: 'https://metromarketsgmbh-help.freshdesk.com/pt-PT/support/tickets/new',
  [CountryCode.Netherlands]: 'https://metromarketsgmbh-help.freshdesk.com/nl/support/tickets/new',
  [CountryCode.France]: 'https://metromarketsgmbh-help.freshdesk.com/fr/support/tickets/new',
};

export const FSD_EXTERNAL_LINK_DE = 'https://lieferservice.metro.de/shop/search';
export const FSD_EXTERNAL_LINK_ES = 'https://servicio-distribucion-hosteleria.makro.es/shop/search';
export const FSD_EXTERNAL_LINK_IT = 'https://consegne.metro.it/shop/search';
export const FSD_EXTERNAL_LINK_PT = 'https://entregas.makro.pt/shop/search';
export const FSD_EXTERNAL_LINK_NL = 'https://horecabezorgservice.makro.nl/shop/search';
export const FSD_EXTERNAL_LINK_FR = 'http://livraison.metro.fr/shop/search';

export const FSD_EXTERNAL_LINK = {
  [CountryCode.Germany]: FSD_EXTERNAL_LINK_DE,
  [CountryCode.Spain]: FSD_EXTERNAL_LINK_ES,
  [CountryCode.Italy]: FSD_EXTERNAL_LINK_IT,
  [CountryCode.Portugal]: FSD_EXTERNAL_LINK_PT,
  [CountryCode.Netherlands]: FSD_EXTERNAL_LINK_NL,
  [CountryCode.France]: FSD_EXTERNAL_LINK_FR,
};

export const MULTI_MARKET_LINKS = {
  [CountryCode.Germany]: null,
  [CountryCode.Spain]: {
    LEGAL_TERMS_AND_CONDITIONS_LINK: LEGAL_TERMS_AND_CONDITIONS_LINK_ES,
    LEGAL_PRIVACY_POLICY_LINK: LEGAL_PRIVACY_POLICY_LINK_ES,
    LEGAL_PRIVACY_COOKIES_LINK: LEGAL_PRIVACY_COOKIES_LINK_ES,
    HOME_LINK_TEXT: LEGAL_IMPRINT_EXTERNAL_LINK_ES,
    HOME_LINK_TEXT_1: HOME_LINK_TEXT_1_ES,
    CONDITION_LINK_TEXT: CONDITION_LINK_TEXT_ES,
  },
};

export const CURRENT_MARKET_LINKS = () => MULTI_MARKET_LINKS[MarketDetectionUtil.getCountryCode()];

// Cross-app links;

export function getOrderHistoryLink(): string {
  return `${ORDER_HISTORY_LINK}`;
}

export function getProductPageLink(itemId: string): string {
  return `/${APP_PRODUCT_ROUTE}/${itemId}`;
}

export const FRESHDESK_DE_LINK = 'https://metro-markets.freshdesk.com/de/support/home';

export const MAGIC_LINK_EXPIRY_QUERY_PARAM = 'magic_link_expiry';
export const RESET_PASSWORD_SUCCESS_QUERY_PARAM = 'reset_password_success';

export const FOOD_CATEGORY_LINKS = {
  [CountryCode.Germany]: `/${APP_CATEGORY_ROUTE}/lebensmittel`,
};
